const SIGNUP_FLOW_TYPE = {
  ONBOARD: 'onboard',
};

export const getSignupFlowType = () => SIGNUP_FLOW_TYPE.ONBOARD;

export const isSimpleSignupFlow = () => false;


export const getUserEmail = (user) => {
  let email = user.attributes.email;
  if (!email) {
    const identities = JSON.parse(user.attributes.identities);
    if (identities[0].providerType === "SignInWithApple") {
      email = user.attributes.preferred_username;
    }
  }

  return email;
}
